window.theme = window.theme || {};
window.theme.RS = window.theme.RS || {};

window.theme.RS.FooterNewsletter = (function() {
  var Footer = {};
  var loadedEvent = new CustomEvent('RS:FooterNewsletter:loaded');
  var HIDE_CLASS = 'rs-invisible';
  var SHOW_CLASS = 'rs-visible';
  var ERROR_CLASS = 'error';
  var ERROR_SELECTOR = '.footer__newsletter-error';
  var INPUT_CONT_SEL = '[data-input]';
  var DEFAULT_ERROR_SEL = '[data-default-err]';
  var ATTENTIVE_SUBSCRIBE = '/api/v1/attentive';
  var ATTENTIVE_SUBMIT_TRIGGER = '[data-action="attentive-submit"]';
  var ATTENTIVE_FORM_SELECTOR ='.attentive-mobile-form';
  var ATTENTIVE_DEFAULT_ERROR = window.theme.strings.attentive.subscriptions.form.errors.submitDefault;
  var ATTENTIVE_PHONE_ERROR = window.theme.strings.attentive.subscriptions.form.errors.phone;
  var KLAVIYO_SUBMIT_TRIGGER = '[data-action="klaviyo-submit"]';
  var KLAVIYO_FORM_SELECTOR = '.klaviyo-form';
  var SUCCESS_MSG_SELECTOR = '.footer__newsletter--success';
  var KLAVIYO_DEFAULT_ERROR = window.theme.strings.klaviyo.subscriptions.form.errors.submitDefault;
  var SUBMIT_DISABLE_CLASS = 'disabled';

  Footer.getExternalAppUrl = function getExternalAppUrl() {
    var url = '';
    if (window.theme.themeSettings && window.theme.themeSettings.roswell_ext_url) {
      url = window.theme.themeSettings.roswell_ext_url;
    }

    return url;
  };

  Footer.convertFormData = function convertFormData(formData) {
    var data = {};
   
    if (formData && formData.entries) {
      for(var pair of formData.entries()) {
        data[pair[0]] =  pair[1];
      }
    }
    return data;
  };
  Footer.initFooterSignUp = function initFooterSignUp(containerSelector){

    var container = containerSelector ? document.querySelector(containerSelector) : null;

    if (container) {
      var hiddenClass = 'fine-print--hidden'
      var mobileForm = container.querySelector('.attentive-mobile-form-wrapper');
      var emailForm = container.querySelector('.klaviyo-email-form-wrapper');
      var emailInput = container.querySelector('.footer__newsletter--input');
      var emailFinePrint = container.querySelector('.email-fine-print-wrapper');
      var mobileInput = container.querySelector('.footer__newsletter--mobile--input');
      var mobileFinePrint = container.querySelector('.mobile-fine-print-wrapper');
      var inputEmailBorder = container.querySelector('.email-input');
      var inputMobileBorder = container.querySelector('.phone-input');

      var setHeights = function() {
        var heightEmailFP = emailFinePrint.offsetHeight;
        var visibleEmailHeight = heightEmailFP + "px";
        var heightMobileFP = mobileFinePrint.offsetHeight;
        var visibileMobileHeight = heightMobileFP + "px";

        emailFinePrint.style.height = visibleEmailHeight;
        emailFinePrint.classList.add(hiddenClass);
  
        mobileFinePrint.style.height = visibileMobileHeight;
        mobileFinePrint.classList.add(hiddenClass);
      };

      var displayFinePrint = function () {
        emailInput.addEventListener('focus', function(e){
          console.log('clicking input')
          emailFinePrint.classList.add('fade-in-text'); 
          emailFinePrint.classList.remove(hiddenClass);
          inputEmailBorder.classList.add('border')
        });

        mobileInput.addEventListener('focus', function(e){
          mobileFinePrint.classList.add('fade-in-text');
          mobileFinePrint.classList.remove(hiddenClass);
          inputMobileBorder.classList.add('border');
        });

        document.body.addEventListener('click', function(e){
          if(!emailForm.contains(e.target)){
            emailFinePrint.classList.remove('fade-in-text'); 
            inputEmailBorder.classList.remove('border');
            emailFinePrint.classList.add(hiddenClass);
            Footer.resetErrors(emailForm.querySelector(KLAVIYO_FORM_SELECTOR));
          }
          if(!mobileForm.contains(e.target)){
            mobileFinePrint.classList.remove('fade-in-text');
            inputMobileBorder.classList.remove('border');
            mobileFinePrint.classList.add(hiddenClass);
            Footer.resetErrors(mobileForm.querySelector(ATTENTIVE_FORM_SELECTOR));
          }
        });
      }

      setHeights();
      displayFinePrint();
    }
  };

  Footer.toggleHideClass = function toggleHideClass(show, elem) {
    if (elem) {
      if (show) {
        elem.classList.add(SHOW_CLASS);
        elem.classList.remove(HIDE_CLASS);
      } else {
        elem.classList.add(HIDE_CLASS);
        elem.classList.remove(SHOW_CLASS);
      }
    }
  }

  Footer.resetErrors = function resetErrors(form) {
    var inputcontainers = form ? Array.from(form.querySelectorAll(INPUT_CONT_SEL)) : [];
    var errorContainers = inputcontainers.filter(function(input) {
      return input.classList.contains(ERROR_CLASS);
    });
   
    errorContainers.forEach(function(container) {
      var error = container.querySelector(ERROR_SELECTOR);
      var defaultMsg = ATTENTIVE_DEFAULT_ERROR;
      container.classList.remove(ERROR_CLASS);
      if (error) {
        if (error.dataset.errMsgDefault) {
          defaultMsg = error.dataset.errMsgDefault;
        }
        Footer.toggleHideClass(false, error);

        if (error.innerText !== defaultMsg) {
          error.innerText = error.dataset.errMsgDefault;
        }
      }
    });

    return inputcontainers;

  };

  Footer.validateForm = function validateForm(form) {
    var isValid = true;
    var inputcontainers = Footer.resetErrors(form);
    var len = inputcontainers ? inputcontainers.length : 0;
    var container,
        input,
        inputError,
        errorMsg,
        isRequired,
        defaultMsg,
        regex;

    if (form) {
      for (var i = 0; i < len; i++) {
        container = inputcontainers[i];
        input = container.querySelector('[name="' + container.dataset.input + '"]');
        inputError = container.querySelector(ERROR_SELECTOR);
        
        if (!input) {
          isValid = false;
        } else {
          defaultMsg = inputError.dataset.errMsgDefault || '';
          isRequired = input.required;

          if (input.type === 'checkbox') {
            if (isRequired && !input.checked) {
              isValid = false;
            }
          } else if (isRequired && !input.value) {
            isValid = false;
            errorMsg = inputError.dataset.errMsgRequired;
          } else if (input.dataset.pattern) {
            regex = new RegExp(input.dataset.pattern);

            if (!input.value.match(regex)) {
              isValid = false;
              errorMsg = inputError.dataset.errMsgPattern;
            }
          }
        }

        if (!isValid) {
          errorMsg = errorMsg ? errorMsg : defaultMsg;
          if (errorMsg && inputError.innerText !== errorMsg) {
            inputError.innerText = errorMsg;
          }
          container.classList.add(ERROR_CLASS);
          if (inputError) {
            Footer.toggleHideClass(true, inputError);

          }
          break;
        }
      }
    } else {
      isValid = false;
    }

    return isValid;
  };

  Footer.toggleSubmitDisable = function toggleSubmitDisable(target, isDisabled) {
    if (target) {
      if (isDisabled) {
        target.classList.add(SUBMIT_DISABLE_CLASS);
      } else {
        target.classList.remove(SUBMIT_DISABLE_CLASS);
      }
    }
  };

  Footer.attentiveOnSubmitError = function attentiveOnSubmitError(error, form) {
    var msg = ATTENTIVE_DEFAULT_ERROR;
    var errorMsg = error ? error.message : '';
    var errorElem = form ? form.querySelector(DEFAULT_ERROR_SEL) : null;
    var container = errorElem ? errorElem.closest(INPUT_CONT_SEL) : null;

    if (error) {
      if (container && errorElem) {
        if (error.status === 400 && errorMsg) {
          if ((errorMsg).toLowerCase() === 'bad request') {
            msg = ATTENTIVE_PHONE_ERROR;
          } else {
            msg = errorMsg || ATTENTIVE_DEFAULT_ERROR;
          }
        }

        errorElem.innerText = msg;
        container.classList.add(ERROR_CLASS);
        Footer.toggleHideClass(true, errorElem);
      }
    }
  };

  Footer.klaviyoOnSubmitError = function klaviyoOnSubmitError(form) {
    var msg = KLAVIYO_DEFAULT_ERROR;
    var errorElem = form ? form.querySelector(DEFAULT_ERROR_SEL) : null;
    var container = errorElem ? errorElem.closest(INPUT_CONT_SEL) : null;

    if (container && errorElem) {
      errorElem.innerText = msg;
      container.classList.add(ERROR_CLASS);
      Footer.toggleHideClass(true, errorElem);
    }
  };

  Footer.sumbitSuccess = function attentiveSubmitSuccess(form) {
    var parent = form ? form.parentNode : null;
    var successElem = parent ? parent.querySelector(SUCCESS_MSG_SELECTOR) : null;
    if (successElem) {
      form.classList.add('hidden');
      Footer.toggleHideClass(true, successElem);
    }
  };

  Footer.attentiveSubmitHandler = function attentiveSubmitHandler(e, target, form) {
    var formData = {};
    var extUrl = Footer.getExternalAppUrl();
    e.preventDefault();

    Footer.toggleSubmitDisable(target, true);

    if (Footer.validateForm(form) && extUrl) {
      formData = Footer.convertFormData(new FormData(form));
      var data = {
        user: {
          phone: formData.phone
        },
        signUpSourceId: formData.signUpSourceId
      }

      fetch(
        extUrl + ATTENTIVE_SUBSCRIBE,
        {
          method: 'POST',
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify(data)
        }
      )
      .then(function(response) {
          return response.json();
      })
      .then(function(data) {
        Footer.toggleSubmitDisable(target);
        if (data) {
          Footer.resetErrors(form);

          if (data.error) {
            Footer.attentiveOnSubmitError(data.error, form);
          } else {
            Footer.sumbitSuccess(form);
          }
        }
      })
      .catch(function(error) {
        console.error('Error: ', error);
        Footer.attentiveOnSubmitError({}, form);
        Footer.toggleSubmitDisable(target);
      });
    } else {
      Footer.toggleSubmitDisable(target);
    }
  };

  Footer.klaviyoSubmitHandler = function klaviyoSubmitHandler(e, target, form) {
    var formData = {};
    e.preventDefault();

    Footer.toggleSubmitDisable(target, true);

    if (Footer.validateForm(form)) {
      formData = Footer.convertFormData(new FormData(form));

      fetch(
        'https://a.klaviyo.com/client/subscriptions/?company_id=HsE2Re',
        {
          method: 'POST',
          headers: { revision: '2024-02-15', 'content-type': 'application/json' },
          body: JSON.stringify({
            data: {
              type: "subscription",
              attributes: {
                profile: {
                  data: {
                    type: 'profile',
                    attributes: {
                      email: formData.email
                    }
                  }
                }
              },
              relationships: {
                list: {
                  data: {
                    type: 'list',
                    id: formData.g
                  }
                }
              }
            }
          })
        }
      )
      .then(function(response) {
        // There doesn't seem to be a response body to parse
        Footer.toggleSubmitDisable(target);

        if (response) {
          Footer.resetErrors(form);

          if (!response.ok) {
            Footer.klaviyoOnSubmitError(form);
          } else {
            Footer.sumbitSuccess(form);

            if (window.klaviyo && klaviyo.push) {
              klaviyo.push(["identify", { $email: formData.email || '' }]);
              klaviyo.push(["trackActivity"]);
            }

          }
        }
      })
      .catch(function(error) {
        console.error('Error: ', error);
        Footer.toggleSubmitDisable(target);
      });
    } else {
      Footer.toggleSubmitDisable(target);
    }
  };

  Footer.registerSubmitHandlers = function registerSubmitHandlers(config) {
    var submitLen = 0;
    var submits;

    if (
      config
      && config.submitSelector
      && config.formSelector
      && config.callback
      && typeof(config.callback) === 'function'
    ) {
      submits = document.querySelectorAll(config.submitSelector) || [];
  
      if (submits.length) {
        submitLen = submits.length;
        for (var i = 0; i < submitLen; i++) {
          (function(elem) {
            var form;
            if (elem) {
              form = elem.closest(config.formSelector);
              elem.addEventListener('click', function(e) {
                var target = this;
                config.callback(e, target, form);
              });
            }
          })(submits[i]);
        }
      }
    }
  };

  Footer.attentiveRegisterSubmitHandlers = function attentiveRegisterSubmitHandlers() {
    var submitLen = 0;
    var submits;

    submits = document.querySelectorAll(ATTENTIVE_SUBMIT_TRIGGER) || [];

    if (submits.length) {
      submitLen = submits.length;
      for (var i = 0; i < submitLen; i++) {
        (function(elem) {
          var form;
          if (elem) {
            form = elem.closest(ATTENTIVE_FORM_SELECTOR);
            elem.addEventListener('click', function(e) {
              var target = this;
              Footer.attentiveSubmitHandler(e, target, form);
            });
          }
        })(submits[i]);
      }
    }
  };

  Footer.initGlobalFooter = function initGlobalFooter() {
    document.addEventListener('DOMContentLoaded', function() {
      var desktopSignUpSelector = "#signup-container-desktop";
      var mobileSignUpSelector = "#signup-container-mobile";
      var FooterNewsletter = window.theme.RS.FooterNewsletter;

      if (FooterNewsletter) {
        FooterNewsletter.initFooterSignUp(desktopSignUpSelector);
        FooterNewsletter.initFooterSignUp(mobileSignUpSelector);
        Footer.registerSubmitHandlers({
          submitSelector: ATTENTIVE_SUBMIT_TRIGGER,
          formSelector: ATTENTIVE_FORM_SELECTOR,
          callback: Footer.attentiveSubmitHandler
        });
        Footer.registerSubmitHandlers({
          submitSelector: KLAVIYO_SUBMIT_TRIGGER,
          formSelector: KLAVIYO_FORM_SELECTOR,
          callback: Footer.klaviyoSubmitHandler
        });
      }

    });
  };

  document.dispatchEvent(loadedEvent);

  return Footer;
})();

// Initialize Footer Form
window.theme.RS.FooterNewsletter.initGlobalFooter();